import React from 'react';
import { useOrgData } from '../../contexts/OrgDataContext';
import { useLocale } from '../../contexts/LocaleContext';
import { DivisionKey } from '../../types/orgchart.types';
import './Legend.css';

export const Legend: React.FC = () => {
  const { divisions, hiddenDivisions, toggleDivision } = useOrgData();
  const { t } = useLocale();

  const divisionOrder: DivisionKey[] = [
    'executive', 'hr', 'sales', 'finance', 'operations', 'quality', 'bizdev'
  ];

  return (
    <div className="legend">
      <div className="legend-title">{t('legend.divisions')}</div>
      <div className="legend-items">
        {divisionOrder.map(key => {
          const division = divisions[key];
          const isHidden = hiddenDivisions.has(key);
          const isExecutive = key === 'executive';

          return (
            <div
              key={key}
              className={`legend-item ${isHidden ? 'hidden' : ''} ${isExecutive ? 'executive' : ''}`}
              onClick={() => toggleDivision(key)}
              title={isExecutive ? t('legend.cannotHideExecutive') : t('legend.clickToToggle', { name: division.name })}
            >
              <div
                className="legend-dot"
                style={{ background: division.color }}
              />
              <span>{division.name} ({t('legend.division', { number: division.number })})</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
